'use client';

import { PropsWithChildren } from 'react';
import { ThemeProvider } from 'styled-components';

import { CalmTheme, GlobalStyle } from '@calm-web/design-system';

import StyledComponentsRegistry from '@/components/layout/StyledComponentsRegistry';

const DesignSystemProvider = ({ children }: PropsWithChildren) => {
	return (
		<StyledComponentsRegistry>
			<>
				<GlobalStyle />
				<ThemeProvider theme={CalmTheme}>{children}</ThemeProvider>
			</>
		</StyledComponentsRegistry>
	);
};

export default DesignSystemProvider;
